module.exports = __webpack_public_path__ + "img/setteing.ba166206.svg";